import React from "react";
import { Platform } from "react-native";

import { G, Line, Text } from "react-native-svg";

import { BOARD_BG } from "../../theme/boardColors";
import type { BoardLabel } from "./boardLayout";
import { LABEL_FONT_FAMILY, LABEL_HALO, LABEL_WEIGHT } from "./constants";

/** Web draws the halo with paint-order; native draws a halo pass first. */
const PAINT_ORDER = Platform.OS === "web";

interface BoardLabelsProps {
  labels: BoardLabel[];
  color: string;
}

const BoardLabels: React.FC<BoardLabelsProps> = ({ labels, color }) => (
  <G>
    {labels.map((l) => {
      const fill = l.color ?? color;
      const common = {
        x: l.x,
        y: l.y,
        textAnchor: "middle" as const,
        fontSize: l.fontSize,
        fontWeight: LABEL_WEIGHT,
        fontFamily: LABEL_FONT_FAMILY,
      };
      const halo = {
        stroke: BOARD_BG,
        strokeWidth: LABEL_HALO,
        strokeLinejoin: "round" as const,
      };
      return (
        <G key={l.id} opacity={l.opacity}>
          {l.leader && (
            <Line
              {...l.leader}
              stroke={fill}
              strokeWidth={1}
              opacity={0.45}
              strokeLinecap="round"
            />
          )}
          {PAINT_ORDER ? (
            <Text
              {...common}
              {...halo}
              {...({ paintOrder: "stroke" } as object)}
              fill={fill}
            >
              {l.text}
            </Text>
          ) : (
            <>
              <Text {...common} {...halo} fill={BOARD_BG}>
                {l.text}
              </Text>
              <Text {...common} fill={fill}>
                {l.text}
              </Text>
            </>
          )}
        </G>
      );
    })}
  </G>
);

export default BoardLabels;
